import React, { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import "material-icons/iconfont/material-icons.css";

const DatePicker_book = (props) => {
  const handleFocus = () => {
    props.txtAdMDob.current.setFocus();
  };
  function range(start, end) {
    var ans = [];
    for (let i = start; i <= end; i++) {
      ans.push(i);
    }
    return ans;
  }
  let getYear = (dates) => {
    let currentYear = dates.getFullYear();
    return currentYear;
  };

  let getMonth = (dates) => {
    let months = dates.getMonth();
    return months;
  };
  // const [startDate, setStartDate] = useState(props.fieldInput);
  // const years = range(2025, getYear(new Date()) + 5);
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 6 }, (_, i) => currentYear + i);
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  return (
    <div className="w-100">
      <DatePicker
        renderCustomHeader={({
          date,
          changeYear,
          changeMonth,
          decreaseMonth,
          increaseMonth,
          prevMonthButtonDisabled,
          nextMonthButtonDisabled,
        }) => (
          <div
            style={{
              margin: 10,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <button
              type="button"
              class="PrevButton_date"
              onClick={decreaseMonth}
              disabled={prevMonthButtonDisabled}
            >
              <span class="material-icons">chevron_left</span>
            </button>
            <select
              className="react-datepicker_Select"
              value={getYear(date)}
              onChange={({ target: { value } }) => {
                // props.handleYearChange && props.handleYearChange(value,props.name);
                changeYear(value);
              }}
            >
              {years.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>

            <select
              className="react-datepicker_Select"
              value={months[getMonth(date)]}
              onChange={({ target: { value } }) => {
                // props.handleMonthChange && props.handleMonthChange(value,props.name);
                changeMonth(months.indexOf(value));
              }}
            >
              {months.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>

            <button
              type="button"
              class="PrevButton_date"
              onClick={increaseMonth}
              disabled={nextMonthButtonDisabled}
            >
              <span class="material-icons">chevron_right</span>
            </button>
          </div>
        )}
        onChange={
          props.handleIdChange
            ? (date) =>
                props.handleIdChange(
                  date,
                  props.fieldsId,
                  props.name,
                  props.indexS,
                  props.bookId
                )
            : (date) => props.handleChange(date, props.name)
        }
        showYearDropdown
        value={props.fieldInput}
        id={props.name}
        ref={props.txtAdMDob}
        name={props.name}
        className={
          props.class
            ? `${props.class} w-100 `
            : `Inputs w-100  ${props.classDisabled ? props.classDisabled : ""} `
        }
        dateFormat="DD/MM/YYYY"
        readOnly={props.readOnly ? props.readOnly : ""}
        minDate={props.minDate !== undefined ? new Date(props.minDate) : ""}
        maxDate={props.maxDate !== undefined ? new Date(props.maxDate) : ""}
        placeholderText="DD/MM/YYYY" // Set your custom placeholder here
        disabled={props.disabledProperty}
      />
      <span
        onClick={handleFocus}
        className={`${props.IconInput} material-icons-outlined Admission_Payment_data`}
      >
        calendar_month
      </span>
      {props.errors_date && (
        <small
          style={{ position: "relative", right: "20px" }}
          className={`error_message mt-2`}
        >
          {props.errors_date}
        </small>
      )}
    </div>
  );
};
export default DatePicker_book;
